import useWindowSize from "@hooks/useWindowSize";

const useIsSmallOrSmallerScreen = () => {
  const { screenWidth } = useWindowSize();
  return screenWidth === "xs" || screenWidth === "sm";
};

export default useIsSmallOrSmallerScreen;
